import { render, staticRenderFns } from "./Accompagnement.vue?vue&type=template&id=3dedda2c&"
import script from "./Accompagnement.vue?vue&type=script&lang=js&"
export * from "./Accompagnement.vue?vue&type=script&lang=js&"
import style0 from "./Accompagnement.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports